<template>
  <div class="research-creater" v-loading="loading">
    <div class="form-content">
      <div class="title-content">统计图表名称</div>
      <el-input :maxlength="100" placeholder="请输入统计图表名称" v-model="title"></el-input>
    </div>
    <div class="form-content" :style="{ paddingTop: '6px' }">
      <el-radio v-model="type" label="numChart">
        <span>基础模型</span>
        <span>（可创建饼图、柱状图、条形图、折线图、数值图）</span>
      </el-radio>
    </div>
    <div class="form-content">
      <el-radio v-model="type" label="tableAnalysisChart" :disabled="!courseDetail._source.isSuperModel">
        <span>高级模型</span>
        <span>（可创建多元回归分析）</span>
      </el-radio>
    </div>
    <div class="form-content" v-if="!courseDetail._source.isSuperModel">
      <span class="tip-text">温馨提示：当前课题无法创建高级模型。</span>
    </div>
    <div class="tool-btns">
      <el-button type="primary" @click="savePointHandle({ type })">立即创建</el-button>
    </div>
    <div class="recommend-content" v-if="false">
      <div class="title-content">推荐研究点</div>
      <div class="recommend-tip">根据你选择的数据集，为你推荐以下4个研究点：</div>
      <div class="recommend-ul">
        <div
          class="recommend-li"
          :class="item === recommendIndex ? 'is-active' : ''"
          @click="recommendIndex = item"
          v-for="item in 4"
          :key="item"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { services } from '@/service';
import { chartDefaultConfig } from '@/constantEnum';
import { fetchMaxIndex } from '@/lib/utils';
import { chartThemeColors } from '@/constant';

export default {
  data() {
    return {
      title: '',
      type: 'numChart',
      recommendIndex: -1,
      loading: false
    };
  },
  props: {
    courseDetail: {
      type: Object,
      required: true
    }
  },
  methods: {
    async savePointHandle({ type, byVipCallback = false }) {
      const title = this.title;
      if (!title) {
        this.$message.warning('请输入研究点名称');
        return;
      }
      try {
        this.loading = true;
        const charts = [...(this.courseDetail._source.chart || [])];
        const maxIndexId = fetchMaxIndex(charts);
        const newChart = {
          index_id: maxIndexId + 1,
          title,
          conditionTemp: '',
          colors: chartThemeColors[0],
          dataSet: JSON.stringify({}),
          height: 1200,
          width: 1200,
          x: 0,
          y: 0,
          type,
          fields: this.courseDetail._source.fields,
          chartConfig: chartDefaultConfig[type] || {},
          historyList: '[]',
          rows: [],
          columns: [],
          statistics: [],
          relationFilterVal: 'case',
          relationFilterName: '以案件为单位'
        };
        charts.unshift(newChart);
        await services.courseware.saveCourseware(this.courseDetail._id, {
          ...this.courseDetail._source,
          refresh: byVipCallback ? true : !!this.courseDetail._source.refresh,
          chart: charts
        });
        services.logger.handleLog({
          operateName: '创建研究点',
          toPathName: 'caseResearch',
          apiUrl: '/nlp/case/update/case/chart/data',
          otherParams: { info: [title] }
        });
        if (type === 'tableAnalysisChart') {
          services.logger.handleLog({
            operateName: '创建高级模型',
            toPathName: 'caseResearch',
            apiUrl: '/nlp/case/update/case/chart/data'
          });
        }

        this.$emit('success', { charts, newChart });
      } catch (err) {
        this.$error(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.research-creater {
  .title-content {
    color: rgba(#3d465a, 0.9);
    font-size: 14px;
    margin: 10px 0;
  }

  .form-content {
    margin-bottom: 10px;

    .tip-text {
      font-size: 12px;
      color: rgba(#3d465a, 0.9);
      font-weight: 300;
    }
  }

  .tool-btns {
    text-align: right;
    margin: 30px 0;
  }

  .recommend-content {
    box-sizing: border-box;
    padding: 20px 0;
    border-top: 1px solid #e8ebef;

    .recommend-tip {
      color: #77839e;
      font-size: 12px;
      margin-bottom: 20px;
    }

    .recommend-ul {
      display: flex;
      flex-wrap: wrap;
      .recommend-li {
        box-sizing: border-box;
        width: 260px;
        height: 220px;
        box-shadow: 0px 0px 4px 1px rgba(129, 150, 180, 0.16);
        border-radius: 10px;
        margin-right: 20px;
        margin-bottom: 20px;
        cursor: pointer;

        &.is-active {
          border: 1px solid #0c93f2;
        }
      }
    }
  }
}
</style>
